import axiosInstance from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";

export const listEnquiries = (qData?: QData) => {
  return axiosInstance.get("/enquiry", { params: qData });
};

export const getEnquiryDetail = (id: string) => {
  return axiosInstance.get(`/enquiry/${id}`);
};

export const deleteEnquiry = (id: string) => {
  return axiosInstance.delete(`/enquiry/${id}`);
};

export const updateEnquiryStatus = (id: string, status: string, soldAt?: string | null) => {
  return axiosInstance.put(`/enquiry/${id}/status`, soldAt !== undefined ? { status, soldAt } : { status });
};

export const addEnquiryReply = (id: string, reply: string) => {
  return axiosInstance.put(`/enquiry/${id}/reply`, { reply });
};

export const editEnquiryCorrespondence = (
  id: string,
  correspondenceId: string,
  text: string,
) => {
  return axiosInstance.put(`/enquiry/${id}/correspondence/${correspondenceId}`, { text });
};

export const deleteEnquiryCorrespondence = (id: string, correspondenceId: string) => {
  return axiosInstance.delete(`/enquiry/${id}/correspondence/${correspondenceId}`);
};

export const exportEnquiriesCsv = async (): Promise<Blob> => {
  const res = await axiosInstance.get("/enquiry/bulk/export", { responseType: "blob" });
  return res.data;
};
